import React, { FunctionComponent } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import AddLinkIcon from '@mui/icons-material/AddLink';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import { Report } from '../../../entities';
import { formatDateTime } from '../../../utils/format-date';
import { createUserReportPath, labels } from '../../../constants';
import { useParams } from 'react-router-dom';

interface UserListTableProps {
  reports: Report[];
}

export const UserReportsTable: FunctionComponent<UserListTableProps> = ({
  reports,
}) => {
  const { uid } = useParams<{ uid: string }>();

  if (!uid) {
    return <p>uidが取得できませんでした</p>;
  }

  return (
    <Card>
      <CardHeader title={labels.data.user.reports} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{labels.data.userReport.createdAt}</TableCell>
            <TableCell>{labels.data.userReport.version}</TableCell>
            <TableCell>モード</TableCell>
            <TableCell>{labels.data.userReport.url}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reports.map((report) => {
            const userReportPath = createUserReportPath(uid, report.reportId);

            return (
              <TableRow key={report.reportId}>
                <TableCell>{formatDateTime(report.createdAt)}</TableCell>
                <TableCell>{report.version}</TableCell>

                {/* モード表示列を追加 */}
                <TableCell>
                  {report.isSatorujapanMode ? (
                    <span
                      style={{
                        color: '#9c27b0',
                        fontWeight: 'bold',
                        fontSize: '0.8em',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <PrivacyTipIcon
                        fontSize='small'
                        style={{ marginRight: '4px' }}
                      />
                      サトルジャパン2次審査用
                    </span>
                  ) : (
                    <span style={{ color: '#1976d2' }}>通常</span>
                  )}
                </TableCell>

                {/* レポート作成中はローディングアイコンを表示 */}
                <TableCell>
                  {report.isProcessing ? (
                    <CircularProgress size={24} />
                  ) : report.isSatorujapanMode ? (
                    // サトルジャパンモードの場合は専用リンクのみ表示
                    <Button
                      href={`${userReportPath}?mode=satorujapan`}
                      target='_blank'
                      color='secondary'
                      variant='contained'
                      size='small'
                      startIcon={<AddLinkIcon fontSize='small' />}
                    >
                      カルテを開く
                    </Button>
                  ) : (
                    // 通常モードの場合は標準リンクとデバッグリンクを表示
                    <>
                      <Button
                        href={userReportPath}
                        target='_blank'
                        startIcon={<AddLinkIcon fontSize='small' />}
                        size='small'
                        color='primary'
                        variant='contained'
                        sx={{ mr: 1 }}
                      >
                        カルテを開く
                      </Button>
                      <Button
                        href={`${userReportPath}?mode=debug`}
                        target='_blank'
                        startIcon={<PrivacyTipIcon fontSize='small' />}
                        size='small'
                        color='info'
                      >
                        デバッグモード
                      </Button>
                    </>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Card>
  );
};
